/**
 * Added loft bed and holds orientation of bed, desk and cabinet
 */
class LoftBedComponent {
    constructor(mirrored, inwardDesk, inwardCabinet) {
        this.typeId = LoftBedComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.mirrored = mirrored;
        this.inwardDesk = inwardDesk;
        this.inwardCabinet = inwardCabinet;
    }
    eq(other) {
        return (this.mirrored === other.mirrored &&
            this.inwardDesk === other.inwardCabinet &&
            this.inwardCabinet === other.inwardCabinet);
    }
}
LoftBedComponent.id = 2091;
export default LoftBedComponent;
//# sourceMappingURL=LoftBedComponent.js.map